import {WebFormModel} from "capitalist-shared/src/core/model";
import {
  RemoteRequestState,
} from '@/backoffice/components/pages/taxrules/taxrules';
import {encryptPassword} from '@/core/encryption/Encryption';
import httpAxiosApi from "capitalist-shared/src/core/axios.errors.handle";

export class ModelValidationError extends Error {
  attribute = ''

  constructor(message: string, attribute: string) {
    super(message);
    this.attribute = attribute;
  }
}

export class RegistrationModel extends WebFormModel {
  submitstate: RemoteRequestState = new RemoteRequestState();

  values: {
    activity_other: string,
    telegram: string;
    phone: string;
    skype: string;
    login: string;
    password: string;
    password2: string;
    nickname: string;
    email: string;
    userType: string;
    pinPassword: string;
    captchaCode: string;
    acceptedAgreement: boolean;
    newsletter: boolean;
    activity: string;
    website: string;

    inviteCode: string;
    referrer: string;
    refCode: string;
  } = {
    activity_other: '',
    telegram: '',
    website: '',
    phone: '',
    skype: '',
    password: '',
    password2: '',
    nickname: '',
    login: '',
    email: '',
    userType: 'INDIVIDUAL',
    pinPassword: '',
    captchaCode: '',
    acceptedAgreement: false,
    newsletter: false,
    activity: '',
    inviteCode: '',
    referrer: '',
    refCode: '',
  };

  categories = []

  async getCategories() {
    return httpAxiosApi.get('/webapi/auth/reg/categories').then(
      (response) => {
        return this.categories = [...response.data.categories];
      })
  }

  async loadCategories() {
    for (let i = 0; i < 5; i++) {
      try {
        return await httpAxiosApi.get('/webapi/auth/reg/categories').then(
          (response) => {
            return this.categories = [...response.data.categories];
          });
      } catch (e) {

      }
    }
    return [];
  }


  obfuscatePasswordForVerification(password?: string): string {
    //const items = ['*', '-', '(', '!', 'r'];
    return password && password.length > 0 ? password : '';
    // return password && password.length > 0 ?
    //   (new Array(password.length + 1)).join('*') /*+ CryptoJS.SHA1(password).toString(CryptoJS.enc.Base64)*/
    //   /*CryptoJS.SHA1(password).toString(CryptoJS.enc.Base64)*/ : '';
  }

  validatePasswords(password: string, password2: string) {
    return new Promise((resolve, reject1) => {
      if (!password || (password.length == 0))
        reject1(new ModelValidationError('Необходимо заполнить пароль.', 'password'));
      if (!password2 || (password2.length == 0))
        reject1(new ModelValidationError('Необходимо повторить пароль.', 'password2'));
      if (password.localeCompare(password2) != 0)
        reject1(new ModelValidationError('Пароли не совпадают.', 'password2'));
      if ((password.length > 40) || (password.length < 6))
        reject1(new ModelValidationError('Длина пароля должна быть от 6 до 40 символов.', 'password'));
      if ((password2.length > 40) || (password2.length < 6))
        reject1(new ModelValidationError('Длина пароля должна быть от 6 до 40 символов.', 'password2'));
      resolve('ok');
    });
  }

  submit() {
    this.submitstate.loadStart();

    return this.validatePasswords(this.values.password, this.values.password2).catch((err) => {
      this.submitstate.loadError();
      if (err.attribute) {
        this.errors.set(err.attribute, err.message);
      }
      throw err;
    }).then(() => {

      const reg = new Registrator();
      return reg.getAttributes(this.values.login).then((response: any) => {
        const values = {...this.values};
        const attributes = response.data.model.securityAttributes;
        if ((values.password.length > 0) && (values.password == values.password2)) {
          values.password = encryptPassword(values.password, attributes.modulus, attributes.exponent) as string;
          values.password2 = values.password;
        } else {
          values.password = this.obfuscatePasswordForVerification(values.password);
          values.password2 = this.obfuscatePasswordForVerification(values.password2);
        }
        return values;
      }).then((values: any) => {
        // console.log('then values', values);
        const host = `${process.env.VUE_APP_API_HOST}`;
        return httpAxiosApi.post(`${host}/webapi/auth/reg`, {
          call: 'register', m: values,
        }).catch((err) => {
          this.submitstate.loadError();
          this.checkAxiosError(err);
          // if (err.response.status == 422) {
          //   this.errors.setErrors(err.response.data.model.errors);
          // }
          throw err;
        });
      }).then((data: any) => {
        this.submitstate.loadEnd();
        return data;
      })
        .catch((err) => {
          this.submitstate.loadError();
          // if (err.response.status == 422) {
          //     this.errors.setErrors(err.response.data.model.errors);
          // }
          throw err;
        });

    });


  }
}

export class RegistrationSuperShortModel extends WebFormModel {
  submitstate: RemoteRequestState = new RemoteRequestState();

  values: {
    password: string;
    password2: string;
    email: string;
    captchaCode: string;
    acceptedAgreement: boolean;
    newsletter: boolean;
    category: string;

    inviteCode: string;
    referrer: string;
    refCode: string;
  } = {
    password: '',
    password2: '',
    email: '',
    captchaCode: '',
    acceptedAgreement: false,
    newsletter: false,
    category: '',

    inviteCode: '',
    referrer: '',
    refCode: '',
  };



  obfuscatePasswordForVerification(password?: string): string {
    //const items = ['*', '-', '(', '!', 'r'];
    return password && password.length > 0 ? password : '';
    // return password && password.length > 0 ?
    //   (new Array(password.length + 1)).join('*') /*+ CryptoJS.SHA1(password).toString(CryptoJS.enc.Base64)*/
    //   /*CryptoJS.SHA1(password).toString(CryptoJS.enc.Base64)*/ : '';
  }

  validatePasswords(password: string, password2: string) {
    return new Promise((resolve, reject1) => {
      if (!password || (password.length == 0))
        reject1(new ModelValidationError('Необходимо заполнить пароль.', 'password'));
      if (!password2 || (password2.length == 0))
        reject1(new ModelValidationError('Необходимо повторить пароль.', 'password2'));
      if (password.localeCompare(password2) != 0)
        reject1(new ModelValidationError('Пароли не совпадают.', 'password2'));
      if ((password.length > 40) || (password.length < 6))
        reject1(new ModelValidationError('Длина пароля должна быть от 6 до 40 символов.', 'password'));
      if ((password2.length > 40) || (password2.length < 6))
        reject1(new ModelValidationError('Длина пароля должна быть от 6 до 40 символов.', 'password2'));
      resolve('ok');
    });
  }

  submit() {
    this.submitstate.loadStart();

    return this.validatePasswords(this.values.password, this.values.password2).catch((err) => {
      this.submitstate.loadError();
      if (err.attribute) {
        this.errors.set(err.attribute, err.message);
      }
      throw err;
    }).then(() => {

      const reg = new Registrator();
      return reg.getAttributes(this.values.email).then((response: any) => {
        const values = {...this.values};
        const attributes = response.data.model.securityAttributes;
        if ((values.password.length > 0) && (values.password == values.password2)) {
          values.password = encryptPassword(values.password, attributes.modulus, attributes.exponent) as string;
          values.password2 = values.password;
        } else {
          values.password = this.obfuscatePasswordForVerification(values.password);
          values.password2 = this.obfuscatePasswordForVerification(values.password2);
        }
        return values;
      }).then((values: any) => {
        // console.log('then values', values);
        const host = `${process.env.VUE_APP_API_HOST}`;
        return httpAxiosApi.post(`${host}/webapi/auth/reg/registerSuperShortPromo`, {
          call: 'registerSuperShortPromo', m: values,
        }).catch((err) => {
          this.submitstate.loadError();
          this.checkAxiosError(err);
          // if (err.response.status == 422) {
          //   this.errors.setErrors(err.response.data.model.errors);
          // }
          throw err;
        });
      }).then((data: any) => {
        this.submitstate.loadEnd();
        return data;
      })
        .catch((err) => {
          this.submitstate.loadError();
          // if (err.response.status == 422) {
          //     this.errors.setErrors(err.response.data.model.errors);
          // }
          throw err;
        });

    });


  }
}


export enum UsertypeEnum {
  Individual = 'individual',
  Business = 'business'
}

export class Registrator {
  host = `${process.env.VUE_APP_API_HOST}`;


  getAttributes(username: string) {
    return httpAxiosApi.post(`${this.host}/webapi/auth/reg`,
      {call: 'attributes', m: {username}});
  }
}
